import './bootstrap.js';
import './components/Main.jsx';
import './i18n';
console.log("app.js");
